import { SectionHeader } from "./Products";

const STEPS = [
  {
    n: "01",
    title: "Spec & Customize",
    body:
      "Share your facility's needs — number of courts, indoor/outdoor, branding. We translate that into a parts list.",
  },
  {
    n: "02",
    title: "Engineered CAD",
    body:
      "Every part is parametric. We tune wall thickness, magnet strength and finish to your environment.",
  },
  {
    n: "03",
    title: "Printed-to-Order",
    body:
      "Industrial FDM and resin printers run your batch. No injection molds, no minimums, no warehouse fees.",
  },
  {
    n: "04",
    title: "Shipped & Installed",
    body:
      "Parts arrive ready to install. No drilling, no tools, no contractor required for our standard catalog.",
  },
];

const IMG_1 =
  "https://customer-assets.emergentagent.com/job_pickletech-supply/artifacts/yxyxkj1p_PXL_20260506_170144936.jpg";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-white border-b border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <SectionHeader
          eyebrow="03 / Our Process"
          title="Tailored to you. Printed in the USA. On demand."
          sub="We skip the warehouse and the injection molds. Your order is engineered, printed, finished, and shipped — usually within 48 hours."
        />

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 border border-[#E5E5E5]">
          <div className="lg:col-span-5 relative min-h-[360px] lg:min-h-[560px] border-b lg:border-b-0 lg:border-r border-[#E5E5E5] bg-[#0A0A0A]">
            <img
              src={IMG_1}
              alt="3D printing close-up"
              className="absolute inset-0 w-full h-full object-cover opacity-90"
            />
            <div className="absolute inset-0 p-8 flex flex-col justify-between text-white">
              <div className="flex items-center gap-3 font-mono-bb text-[11px] tracking-widest">
                <span className="w-2 h-2 bg-[#DFFF00] inline-block" />
                LIVE PRODUCTION
              </div>
              <div>
                <div className="font-mono-bb text-[11px] tracking-widest text-[#DFFF00]">
                  RUN_07 · MARKER · NUMBERS 1–24
                </div>
                <div className="font-display text-xl mt-2 max-w-sm">
                  Mountain View Pickleball Club · 12 courts
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 divide-y divide-[#E5E5E5]">
            {STEPS.map((s, i) => (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="grid grid-cols-12 gap-4 px-6 md:px-10 py-7 md:py-9 hover:bg-[#FAFAFA] transition-colors group"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="col-span-2 md:col-span-2">
                  <div className="font-mono-bb text-[12px] text-[#525252] tracking-widest">
                    /{s.n}
                  </div>
                </div>
                <div className="col-span-10 md:col-span-10">
                  <h3 className="font-display text-xl md:text-2xl tracking-tight font-medium group-hover:translate-x-1 transition-transform">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[14px] text-[#525252] leading-relaxed max-w-xl">
                    {s.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
